// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.call-intro-modal {
  width: 400px !important;
}

.call-intro-modal .ant-modal-close-x {
  display: none;
}

.call-intro-modal img  {
  width: 300px;
  height: 300px;
}

.call-intro-modal .ant-modal-body {
  padding: 32px 32px 24px;
}

.call-intro-book-title {
  margin-top : 8px;
  margin-bottom: 16px;
}

.call-intro-book-title .ant-typography {
  font-weight: 500;
  color: #444444 !important;
  opacity: 1;
  font-size: 20px;
  line-height: 32px;
}

.call-intro-description, .call-intro-description .ant-typography {
  text-align: left;
  font-size: 14px;
  line-height: 22px;
  color: #444444;
  opacity: 1;
}

.skip-call-btn {
  margin-right: 8px;
}

.action-btn {
  margin-top: 32px;
}
.action-btn .ant-btn {
  padding: 8px 16px 9px;
  text-align: center;
  font-weight: 500;
  font-size: 14px;
  line-height: 19px;
  letter-spacing: 0.56px;
}

.skip-call-btn .ant-btn {
  color: #CCCCCC;
  opacity: 1;
}`, "",{"version":3,"sources":["webpack://./src/v3/legacy_components/UI_V2_Components/shared/WelcomeCall/components/bookIntroModal.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,UAAU;EACV,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,UAAU;AACZ","sourcesContent":[".call-intro-modal {\n  width: 400px !important;\n}\n\n.call-intro-modal .ant-modal-close-x {\n  display: none;\n}\n\n.call-intro-modal img  {\n  width: 300px;\n  height: 300px;\n}\n\n.call-intro-modal .ant-modal-body {\n  padding: 32px 32px 24px;\n}\n\n.call-intro-book-title {\n  margin-top : 8px;\n  margin-bottom: 16px;\n}\n\n.call-intro-book-title .ant-typography {\n  font-weight: 500;\n  color: #444444 !important;\n  opacity: 1;\n  font-size: 20px;\n  line-height: 32px;\n}\n\n.call-intro-description, .call-intro-description .ant-typography {\n  text-align: left;\n  font-size: 14px;\n  line-height: 22px;\n  color: #444444;\n  opacity: 1;\n}\n\n.skip-call-btn {\n  margin-right: 8px;\n}\n\n.action-btn {\n  margin-top: 32px;\n}\n.action-btn .ant-btn {\n  padding: 8px 16px 9px;\n  text-align: center;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 19px;\n  letter-spacing: 0.56px;\n}\n\n.skip-call-btn .ant-btn {\n  color: #CCCCCC;\n  opacity: 1;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
